import { Button, Col, Input, Pagination, Row } from "antd";
import Info from "./info";

const cod_process = [
    {value: "", label: 'Todos'},
    {value: "DEFE", label: 'Pendiente'},
    {value: "MARC", label: 'Marcados'},
    {value: "CRUD", label: 'Crudo'},
    {value: "TEJE", label: 'Tejeduría'},
    {value: "MARC", label: 'Marcados'},
    {value: "TINT", label: 'Tintorería'},
    {value: "ENRO", label: 'Enrollado'},
    {value: "DESP", label: 'Depachos'},
    {value: "REMI", label: 'Remisionado'},
    {value: "FACT", label: 'Facturado'},
    {value: "DELE", label: 'Eliminado'},
]

export default function DataList({ hook, changePanel }){

    const changePage = (page) => {
        hook.setPage(page - 1);
        hook.loadDataOptions(page - 1);
    }

    return(
        <Row>
            <Col lg={24} xs={24}>
                <Button onClick={() => changePanel()}>
                    Atrás
                </Button>
            </Col>
            <Col lg={24} xs={24}>
                <form>
                    <div style={{ margin: '10px 0', display: 'flex', flexDirection: 'row', width: '100%' }}>
                        <Input 
                            style={{ width: '150px', margin: '0 8px' }}
                            autoSave="true"
                            placeholder="Cliente"
                            value={ hook.filter.client }
                            onChange={(e) => {
                                let newFilter = {...hook.filter};
                                newFilter.client = e.target.value ? e.target.value.toUpperCase() : e.target.value;
                                hook.setFilter(newFilter);
                            }}
                        />
                        <Input 
                            style={{ width: '150px', margin: '0 8px' }}
                            autoSave="true"
                            placeholder="Pedido"
                            value={ hook.filter.order }
                            onChange={(e) => {
                                let newFilter = {...hook.filter};
                                newFilter.order = e.target.value;
                                hook.setFilter(newFilter);
                            }}
                        />
                        <Input 
                            style={{ width: '150px', margin: '0 8px' }}
                            autoSave="true"
                            placeholder="Referencia"
                            value={ hook.filter.product }
                            onChange={(e) => {
                                let newFilter = {...hook.filter};
                                newFilter.product = e.target.value;
                                hook.setFilter(newFilter);
                            }}
                        />
                        <Input 
                            style={{ width: '150px', margin: '0 8px' }}
                            autoSave="true"
                            placeholder="Color"
                            value={ hook.filter.color }
                            onChange={(e) => {
                                let newFilter = {...hook.filter};
                                newFilter.color = e.target.value;
                                hook.setFilter(newFilter);
                            }}
                        />
                        {
                            ! hook.filter.not_dispatch &&
                            <select 
                                style={{ width: '150px', margin: '0 8px' }}
                                value={hook.filter.cod_process}
                                onChange={(e) => {
                                    let newFilter = {...hook.filter};
                                    newFilter.cod_process = e.target.value;
                                    hook.setFilter(newFilter);
                                }}
                            >
                                {
                                    cod_process.map((cod, key) => (
                                        <option value={cod.value} key={`option_cod_process_${key}`}>
                                            {cod.label}
                                        </option>
                                    ))
                                }
                            </select>
                        }
                        <div style={{ display: 'flex', flexDirection: 'row', width: '150px', margin: '0 8px' }}>
                            <input 
                                id="not_dispatch"
                                type="checkbox"
                                checked={hook.filter.not_dispatch}
                                onChange={(e) => {
                                    let newFilter = {...hook.filter};
                                    newFilter.not_dispatch = e.target.checked;
                                    hook.setFilter(newFilter);
                                }}
                            />
                            <label style={{ marginLeft: '5px', cursor: 'pointer', height: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }} htmlFor="not_dispatch">Excluir despachados</label>
                        </div>
                        <Button
                            type="primary"
                            onClick={() => {
                                hook.loadDataOptions(0);
                                hook.setPage(0);
                            }}
                        >
                            Buscar
                        </Button>
                    </div>
                </form>
            </Col>
            <Col lg={24} xs={24}>
                <div style={{ width: '100%', margin: '15px 0px' }}>
                <Pagination current={hook.page + 1} onChange={(e) => changePage(e)} total={hook.data.total} pageSize={20} />
                <div style={{ width: '100%', margin: '8px 0' }}>
                    <Info data={hook.data.data} />
                </div>
                <Pagination current={hook.page + 1} onChange={(e) => changePage(e)} total={hook.data.total} pageSize={20} />
                </div>
            </Col>
        </Row>
    );
}